import React, {Fragment} from 'react';
import {Button, Col, Row} from "reactstrap";
import LoadingButton from '../../../../../../Components/Buttons/LoadingButton';
import CustomModal from '../../../../../../Components/Modals/CustomModal';


function StartProductManagementModal(props) {

    const {
        isStartManagementOpen,
        setIsStartManagementOpen,
        managementProduct,
        updateProductManagement } = props;

    return (
        <CustomModal
            header="Product Management"
            isOpen={isStartManagementOpen}
            toggle={() => setIsStartManagementOpen(!isStartManagementOpen)}
            footer={
                <Fragment>
                    <Button
                        style={{fontSize: "small"}}
                        color="success"
                        onClick={() => setIsStartManagementOpen(!isStartManagementOpen)}
                    >
                        Cancel
                    </Button>
                    <LoadingButton
                        loading={props.loading}
                        color="secondary"
                        onClick={() => {
                            setIsStartManagementOpen(!isStartManagementOpen);
                            return updateProductManagement(managementProduct.asin, 'resume');
                        }}
                    >
                       Start Management
                    </LoadingButton>
                    {/* <Button> Pause Management</Button> */}
                </Fragment>
            }
        >
            <Row>
                {/*<Col md="12">*/}
                {/*    For 1 Credit a day, Simpliworks can manage and optimize bids for this product's 1-Click campaigns to maximize ROAS (Return On Ad Spend).*/}
                {/*</Col>*/}
                <Col md="12">
                Starting Simpliworks management for this product. Simpliworks will start  the market data collection, analysis and advertising management.
                </Col>
            </Row>
        </CustomModal>
    )
}

export default StartProductManagementModal;